import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class MessagesService {
  private messageSource = new Subject<{ message: string; type: 'success' | 'error' | 'vacio' }>();
  message$ = this.messageSource.asObservable();

  showMessage(message: string) {
    this.messageSource.next({ type: 'success', message });
  }

  showError(message: string) {
    this.messageSource.next({ type: 'error', message });
  }

}
